import React from 'react';
import Button from '../../Shared/UI/Button/components/Button';

import {
  useRoleShowState,
  useRoleShowActions
} from './RoleShowContext';
import RoleShowLoader from './RoleShowLoader';
import RoleEditModal from './RoleEditModal';
import AddRestrictedActionModal from './AddRestrictedActionModal';
import AddUserToRoleModal from './AddUserToRoleModal';

import {
  removeRestrictedActionFromRole,
  removeUserFromRole,
} from './restApi';

import styles from './Show.module.scss';

const RoleShowContent = ({ role }) => {
  const state = useRoleShowState();
  const { onResponse, onError, openRoleEditModal, openAddRestrictedActionModal, openAddUserToRoleModal } = useRoleShowActions();

  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  const goToRolesIndex = () => {
    location.assign(`/roles/`);
  };

  const goToRestrictedAction = (restrictedAction) => {
    location.assign(`/restricted_actions/${restrictedAction.id}`);
  };

  const goToUser = (user) => {
    location.assign(`/users/${user.id}`);
  };

  return (
    <>
      <section className={styles.section}>
        <Button
          variant="primary"
          onClick={() => goToRolesIndex()}
        >
          View All Roles
        </Button>
      </section>
      <section className={styles.section}>
        <h2 className={styles.tableTitle}>
          Role
        </h2>
        {state?.role && (
          <table className={styles.table}>
            <thead>
              <tr className={styles.tr}>
                <th className={styles.th}>Group Id</th>
                <th className={styles.th}>Role Name</th>
              </tr>
            </thead>
            <tbody>
              <tr key={state?.role.id}>
                <td className={styles.td}>{state?.role.groupId}</td>
                <td className={styles.td}>{state?.role.roleName}</td>
                <td className={styles.td}>
                  <Button
                    variant="primary"
                    onClick={(e) => {
                      e.preventDefault();
                      openRoleEditModal();
                    }}
                  >
                    Edit
                  </Button>
                </td>
              </tr>
            </tbody>
          </table>
        )}
      </section>
      <section className={styles.section}>
        <h2 className={styles.tableTitle}>
          Restricted Actions
        </h2>
        <Button
          variant="primary"
          onClick={() => openAddRestrictedActionModal()}
        >
          Add Restricted Action
        </Button>
        {state?.role?.restrictedActions?.length ? (
          <table className={styles.table}>
            <thead>
              <tr className={styles.tr}>
                <th className={styles.th}>Group Id</th>
                <th className={styles.th}>Restricted Action Name</th>
                <th className={styles.th}>Resource Id</th>
                <th className={styles.th}>Resource Type</th>
                <th className={styles.th}>Apply To All Users</th>
              </tr>
            </thead>
            <tbody>
              {state?.role?.restrictedActions?.map(restrictedAction => {
                return (
                  <tr key={restrictedAction.id}>
                    <td className={styles.td}>{restrictedAction.groupId}</td>
                    <td className={styles.td}>{restrictedAction.restrictedActionName}</td>
                    <td className={styles.td}>{restrictedAction.resourceId}</td>
                    <td className={styles.td}>{restrictedAction.resourceType}</td>
                    <td className={styles.td}>{restrictedAction.applyToAllUsers.toString()}</td>
                    <td className={styles.td}>
                      <Button
                        variant="primary"
                        onClick={() => goToRestrictedAction(restrictedAction)}
                      >
                        View Details
                      </Button>
                    </td>
                    <td className={styles.td}>
                      <Button
                        variant="destructive"
                        onClick={() => {
                          removeRestrictedActionFromRole({
                            role,
                            onResponse,
                            onError,
                            body: {
                              restrictedAction,
                              authenticity_token: authenticityToken,
                            },
                          });
                        }}
                      >
                        Remove Restricted Action
                      </Button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        ) : (
          <p className={styles.noContentMessage}>No restricted actions for this role.</p>
        )}
      </section>
      <section className={styles.section}>
        <h2 className={styles.tableTitle}>
          Users
        </h2>
        <Button
          variant="primary"
          onClick={() => openAddUserToRoleModal()}
        >
          Add User
        </Button>
        {state?.role?.users?.length ? (
          <table className={styles.table}>
            <thead>
              <tr className={styles.tr}>
                <th className={styles.th}>First Name</th>
                <th className={styles.th}>Last Name</th>
              </tr>
            </thead>
            <tbody>
              {state?.role?.users?.map(user => {
                return (
                  <tr key={user.id}>
                    <td className={styles.td}>{user.firstName}</td>
                    <td className={styles.td}>{user.lastName}</td>
                    <td className={styles.td}>
                      <Button
                        variant="primary"
                        onClick={() => goToUser(user)}
                      >
                        View Details
                      </Button>
                    </td>
                    <td className={styles.td}>
                      <Button
                        variant="destructive"
                        onClick={() => {
                          removeUserFromRole({
                            role,
                            onResponse,
                            onError,
                            body: {
                              user,
                              authenticity_token: authenticityToken,
                            },
                          });
                        }}
                      >
                        Remove User
                      </Button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        ) : (
          <p className={styles.noContentMessage}>No users with this role.</p>
        )}
      </section>
    </>
  );
};

const Show = ({ role }) => {
  return (
    <>
      <RoleShowLoader role={role} />
      <RoleShowContent role={role} />
      <RoleEditModal />
      <AddRestrictedActionModal role={role} />
      <AddUserToRoleModal role={role} />
    </>
  );
};

export default Show;
